module.exports = __webpack_public_path__ + "img/login.e29458b7.svg";